// Když to hodíme sem, tak se obejdeme CORS problémům s mask-image
// a zároveň to budeme mít zacachované
// https://stackoverflow.com/questions/67710922/web-kit-mask-image-throws-a-cors-error-angular

import { addSVGDataMime } from "./utils/svg-utils.js";

// Jinak bychom mohli použít heart-filled.svg přímo ze souboru, pak se
export const SVG_HEART_MASK_IMAGE_BASE64 = addSVGDataMime(
	"PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwIj4KICA8cGF0aCBkPSJtNDgwLTEyMC01OC01MnEtMTAxLTkxLTE2Ny0xNTdUMTUwLTQ0Ny41UTExMS01MDAgOTUuNS01NDRUODAtNjM0cTAtOTQgNjMtMTU3dDE1Ny02M3E1MiAwIDk5IDIydDgxIDYycTM0LTQwIDgxLTYydDk5LTIycTk0IDAgMTU3IDYzdDYzIDE1N3EwIDQ2LTE1LjUgOTBUODEwLTQ0Ny41UTc3MS0zOTUgNzA1LTMyOVQ1MzgtMTcybC01OCA1MloiLz4KPC9zdmc+"
);
